var custShipLocation;
var product_variants_meta;

if (window.localStorage.getItem('cart-bundled') == 'true') {
  fetch('/cart.js', {cache: "no-store"})
    .then(function(response) {
      return response.json();
    })
    .then(function(response) {
      console.log('CART DATA', response);
      verifyCartContents(response, false, false);
    });
}

function getQuantity (lowest = 1) {
  let quantity = $('.quantity-input').val();

  if (quantity == null) {
    quantity = 1;
  }
  else {
    quantity = Number (quantity);
  }
  
  if (quantity < lowest){
    quantity = lowest;
    $('.quantity-input').val(lowest);
  }

  return quantity;
}

const filterBundleForLowestSize = (currentMetafields) => {
    let filteredMetafields = currentMetafields.filter(({ id, metafields } ) => {
      const { number_in_bundle } = metafields;
      if (number_in_bundle === lowestStartingAmount){
        return true
      } 
      return false
    })

    if (filteredMetafields.length === 0) {
      // Try again with different logic
      filteredMetafields = currentMetafields.filter(({ id, metafields } ) => {
        const { applies_to_starting_amount } = metafields;
        if (applies_to_starting_amount === lowestStartingAmount){
          return true
        } 
        return false
      })
    }
  
    return filteredMetafields
}
const filterMetafieldsByWholeSale = (currentMetafields) => {
  const filteredMetafields = currentMetafields.filter(({ metafields }) => {
    const { wholesale } = metafields;
    return isWholesale === wholesale
  })
    return filteredMetafields
  }

  const filterMetafieldsByQuantity = (quantity, currentMetafields) => {
    const filteredMetafields = currentMetafields.filter(({ id, metafields } ) => {
      const { applies_to_end_amount, applies_to_starting_amount } = metafields;
      if (quantity >= applies_to_starting_amount && quantity <= applies_to_end_amount){
        return true
      } 
      return false
    })
    return filteredMetafields
  }

  const filterMetafieldsByCountry = (location, quantity, currentMetafields, ignoreBundle = false) => {
    const filteredMetafields = currentMetafields.filter(({ id, metafields } ) => {
      const { inventory_levels, number_in_bundle, inventory_policy } = metafields;
      const countryInventoryLevel = inventory_levels[location];

      let _quantity = quantity;

      if (ignoreBundle === false || number_in_bundle > 1) {
        _quantity = Math.floor(quantity / number_in_bundle)
      }

      if (inventory_policy === 'continue') {
        return true;
      } else if (countryInventoryLevel >= _quantity && countryInventoryLevel !== 0){
        return true
      }

      return false
    })
    return filteredMetafields
  }

  const sortMetafieldsByBundleCount = (filteredMetafields, reverse = false) => {
    if (reverse === false) {
      filteredMetafields.sort((a, b) => b.metafields.number_in_bundle - a.metafields.number_in_bundle)
    } else {
      filteredMetafields.sort((a, b) => a.metafields.number_in_bundle - b.metafields.number_in_bundle)
    }
    return filteredMetafields
  }

  const fillCart = (quantity, filteredMetafields) => {
    custShipLocation = getCookie('customer_ship_location');
    const metafield = filteredMetafields [0];

    if (metafield == null) {
      return [];
    }

    const { id } = metafield;

    return [{
      id,
      quantity,
      location: custShipLocation
    }]
  }

  const fillCartWithAppropriateBundles = (quantity, filteredMetafields, allowBundle = false) => {
    const sortedFilteredMetafields = sortMetafieldsByBundleCount(filteredMetafields, !allowBundle);

    custShipLocation = getCookie('customer_ship_location');
    let quantityToFulfill = quantity;

      window.localStorage.setItem('cart-bundled', allowBundle ? 'true' : 'false');

      let __lowestStartingAmount = Infinity;
      let bundleSize = 1;
for (let i=0;i<sortedFilteredMetafields.length;i++){
        const startingAmount = sortedFilteredMetafields[i].metafields.applies_to_starting_amount;
        if (__lowestStartingAmount > startingAmount){
          __lowestStartingAmount = startingAmount;
          bundleSize = sortedFilteredMetafields[i].metafields.number_in_bundle;
        }
      }

      if (__lowestStartingAmount < bundleSize) {
        __lowestStartingAmount = bundleSize;
      }

      const data = [];
      for (let i = 0 ; i < sortedFilteredMetafields.length ; i++ ){
        const { id, metafields: { number_in_bundle }} = sortedFilteredMetafields[i];
        if (allowBundle === false && number_in_bundle != bundleSize) {
          continue; // Added to stop bundling
        }
        const bundleQuantityNeeded = Math.floor(quantityToFulfill / number_in_bundle);

        if (bundleQuantityNeeded === 0) continue
        data.push({
          id: id,
          quantity: bundleQuantityNeeded,
          location: custShipLocation
        })
        quantityToFulfill = quantityToFulfill - bundleQuantityNeeded * number_in_bundle
      }
      return data
}

const filterCartMetafields = (currentMetafields, quantity=null, isBundle = true, reverse = false) => {
  custShipLocation = getCookie('customer_ship_location');

  let filteredMetafields = [ ...currentMetafields ];

    //Filtering based on wholesale variants
    if (isBundle === true) {
      filteredMetafields = filterMetafieldsByWholeSale(filteredMetafields)
    }

    //Filtering based on upper and lower bound quantities
    if (isBundle === true && quantity !== null) {
      filteredMetafields = filterMetafieldsByQuantity(quantity, filteredMetafields)
    }

    //Filtering based by customers country based on cookie
    filteredMetafields = filterMetafieldsByCountry(custShipLocation, quantity, filteredMetafields, !isBundle)

    //Sorting metafields based on bundle count to put largest bundle sizes on top
    if (isBundle === true) {
      filteredMetafields = sortMetafieldsByBundleCount(filteredMetafields, reverse)
    }

    return filteredMetafields
}

const verifyCartContents = (cart, allowBundle = false, animate = true, noReload = false, callback = () => null) => {
    const custShipLocation = getCookie('customer_ship_location');

    const productsInCart = {};
    const lineKeysToRemove = [];
    const cartData = [];

    cart.items.forEach(item => {
        const { variant_id, product_id, quantity, properties = {}, key: lineKey } = item;

        if (properties['_free'] !== undefined) {
            const [amount, linkedProductId] = properties['_free'].split('-');
            // lineKeysToRemove.push(lineKey);

            cartData.push({
                id: linkedProductId,
                quantity: quantity * Number(amount),
                location: custShipLocation,
                properties: { '_freeItem': true }
            });
        }

        if (properties['_freeItem'] !== undefined) {
            lineKeysToRemove.push(lineKey);
        }

        const metafields = cart_product_variants_meta[product_id];
        if (!metafields || metafields.length === 0) return;

        const matchedMetafield = metafields.find(meta => meta.id === variant_id);
        if (!matchedMetafield) return;

        const numberInBundle = matchedMetafield.metafields.number_in_bundle;
        productsInCart[product_id] = (productsInCart[product_id] || 0) + (quantity * Number(numberInBundle));
    });

    const productIdsInCart = Object.keys(productsInCart);
    let reloadNeeded = false;

    productIdsInCart.forEach(productId => {
        const quantity = productsInCart[productId];
        let filteredMetafields = filterMetafieldsByWholeSale(cart_product_variants_meta[productId]);

        filteredMetafields = filterMetafieldsByQuantity(quantity, filteredMetafields);
        filteredMetafields = filterMetafieldsByCountry(custShipLocation, quantity, filteredMetafields, !allowBundle);
        filteredMetafields = sortMetafieldsByBundleCount(filteredMetafields, true);

        const cartBundles = fillCartWithAppropriateBundles(quantity, filteredMetafields, allowBundle);
        cartData.push(...cartBundles);

        if (cart.items.length > cartBundles.length) {
            reloadNeeded = true;
        } else if (cart.items.some(item => !productIdsInCart.includes(String(item.product_id)))) {
            reloadNeeded = true;
        } else if (cart.items.length === cartBundles.length) {
            const newIds = cartBundles.map(({ id }) => id);
            const oldIds = cart.items.map(({ id }) => id);

            if (!newIds.every(id => oldIds.includes(id))) {
                reloadNeeded = true;
            }
        }

        // Add line keys for items with matching variant_ids from `cart_product_variants_meta`
        const targetVariantIds = cart_product_variants_meta[productId].map(meta => meta.id);
        cart.items.forEach(item => {
            if (targetVariantIds.includes(item.variant_id)) {
                lineKeysToRemove.push(item.key);
            }
        });
    });

    handleCartUpdate(lineKeysToRemove, cartData, animate, reloadNeeded, noReload, callback);
};

const handleCartUpdate = (variant_ids, cartData, animate, reloadNeeded, noReload, callback = () => null) => {
  if (typeof removeFromCart !== 'function' || typeof addMultipleToCart !== 'function') {
    setTimeout(() => handleCartUpdate(variant_ids, cartData, animate, reloadNeeded, noReload, callback), 100);
    return;
  }

  removeFromCart(variant_ids, (cartJson) => {
    // Already calls refreshCart once the cart is updated
    addMultipleToCart(cartData, true, animate, callback, false);
  });
}

function addEventToCartPayments() {
  const cart_payment_options = document.querySelectorAll('.additional-checkout-buttons ul li div');

  if (cart_payment_options === undefined || cart_payment_options.length === 0) {
    setTimeout(addEventToCartPayments, 100);
    return;
  }
    
  cart_payment_options.forEach((_) => {
    var new_element = _.cloneNode(true);
    _.parentNode.append(new_element);

    new_element.id = "override-button";
    new_element.style.position = 'absolute !important';
    new_element.style.zIndex = '1 !important';
    new_element.style.top = '0 !important';

    _.parentNode.id = "override-button-container";

    new_element.addEventListener('click', (e) => {
      e.preventDefault();

      $.ajax({
        url: '/cart.js',
        dataType: 'json',
        cache: false,
        success(cart) {
          verifyCartContents(cart, true, false, true, () => _.click());
        }
      });
    }, true);
  });
}

function addEventToCart() {
  const cart_forms = document.querySelector('#cart_form');
  
  if (cart_forms === undefined) {
    setTimeout(addBundleLogic, 100);
    return;
  }

  cart_forms.addEventListener('submit', (e) => {
    $.ajax({
      url: '/cart.js',
      dataType: 'json',
      cache: false,
      success(cart) {
        verifyCartContents(cart, true, false, true);
      }
    });
  });
}

function initAddToCartBundle () {
  custShipLocation = getCookie('customer_ship_location');

  if (product_variants_meta == null) {
    return;
  }

  let initialFilteredMetafields = filterMetafieldsByCountry(custShipLocation, 1, [ ...product_variants_meta ])
  initialFilteredMetafields = filterBundleForLowestSize(initialFilteredMetafields)

  const amountAtLocation = filterMetafieldsByWholeSale(initialFilteredMetafields)

  
  if (amountAtLocation.length === 0){
    $('#add_to_cart_btn').addClass('disabled')
    $('#add_to_cart_btn_text').text("Sold out")
  }
  else {
    $('#add_to_cart_btn').removeClass('disabled')
    $('#add_to_cart_btn_text').text("Add To Cart")
  }

  $('.quantity-input').trigger('change');
}

function initAddToCart () {
  custShipLocation = getCookie('customer_ship_location');

  if (product_variants_meta == null) {
    return;
  }

  let amountAtLocation = filterMetafieldsByCountry(custShipLocation, 1, [ ...product_variants_meta ], true)
  
  if (amountAtLocation.length === 0){
    $('#add_to_cart_btn').addClass('disabled')
    $('#add_to_cart_btn_text').text("Sold out")
  }
  else {
    $('#add_to_cart_btn').removeClass('disabled')
    $('#add_to_cart_btn_text').text("Add To Cart")
  }



  $('.quantity-input').trigger('change');
}
